<template>
  <div>
    <div 
      v-for="n in count" 
      :key="n" 
      class="skeleton-list-item"
      :style="{ height: itemHeight }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonList',
  props: {
    count: {
      type: Number,
      default: 5
    },
    itemHeight: {
      type: String,
      default: '60px'
    }
  }
}
</script>

<style scoped>
.skeleton-list-item {
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 12px;
}

.skeleton-list-item:last-child {
  margin-bottom: 0;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
